import { CalculatorHeaderStyles } from './CalculatorHeader.types'

const makeStyles = (): CalculatorHeaderStyles => ({
	calculatorHeader: {
		margin: '0px',
		padding: '25px 0px'
	}
})

export default makeStyles
